import { Injectable, Injector, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HTTP_INTERCEPTORS,
    HttpResponse,
    HttpHeaders
} from '@angular/common/http';
import { catchError, finalize, map } from 'rxjs/operators';
import { ToastService } from '../ui/services/toast.service';
import { LoaderService } from '../ui/services/loader.service';
import { TranslatorService } from '../../infra/common/localization/lang/translator.service';

@Injectable()
export class PortalExceptionHandlingHttpInterceptor implements HttpInterceptor {
    constructor(
        private toastService: ToastService,
        private loaderService: LoaderService,
        private translator: TranslatorService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // this.loaderService.show();
        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }
        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request)
            .pipe(
                map((event: any) => {
                    if (event instanceof HttpResponse) {
                        const body = event.body;
                        if (body && typeof body.code === 'number') {
                            if (body.code === 0) {
                                return event.clone({ body: body.response });
                            }
                            throw body.response;
                        }
                    }

                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    // this.loaderService.hide();
                    this.showErrorMessage(error);
                    return throwError(error);
                }),
                finalize(() => {
                    // this.loaderService.hide();
                })
            );
    }

    showErrorMessage(error: any) {
        if (error) {
            this.toastService.warning({
                message: error.message,
                title: this.translator.translate('error')
            });
        }
    }
}
